import React from 'react';

interface Props {
	autoSubmit: boolean;
	jwt: string;
	returnTo: string | string[] | null;
}

const ZendeskForm: React.FC<Props> = ({ autoSubmit, jwt, returnTo }) => {
	const formRef = React.useRef<HTMLFormElement | null>(null);

	React.useEffect(() => {
		if (autoSubmit && jwt && returnTo) {
			formRef.current?.submit();
		}
	}, [autoSubmit, jwt, returnTo]);

	if (!jwt) {
		return null;
	}

	return (
		<form
			hidden={true}
			ref={formRef}
			method="post"
			action={`${process.env.GATSBY_ZENDESK_SSO_LINK}/access/jwt?jwt=${jwt}&return_to=${returnTo}`}>
			<input type="text" name="jwt" value={jwt} />
			<input type="text" name="return_to" value={returnTo as string} />
		</form>
	);
};

export default ZendeskForm;
